import { useSeo } from "@/hooks/useSeo";
import { PROJECTS } from "@/data/site";
import { Info } from "lucide-react";

export default function PastProjects() {
  useSeo(
    "Past Projects | Custom Machined Parts | Edgeworks Manufacturing",
    "Example CNC machining projects: stainless components, aluminum fixture plates, replacement machine parts, and small-batch turned parts. Representative examples."
  );

  return (
    <div>
      <section className="border-b border-neutral-800 bg-neutral-900">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-orange-500">Past Projects</p>
          <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter text-white sm:text-5xl">
            Project Examples
          </h1>
          <p className="mt-4 max-w-2xl text-neutral-400">
            A look at real parts machined at Edgeworks — from custom-threaded turned fittings to
            reverse-engineered replacement components. More projects will be added here over time.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-8 sm:grid-cols-2">
          {PROJECTS.map((p, i) => (
            <article key={p.title} className="border border-neutral-800 bg-neutral-950" data-testid={`project-${i}`}>
              <div className="relative aspect-[4/3] border-b border-neutral-800 bg-neutral-900">
                {p.image ? (
                  <img src={p.image} alt={p.title} className="h-full w-full object-contain p-3" loading="lazy" />
                ) : (
                  <div className="flex h-full w-full items-center justify-center bp-grid">
                    <span className="font-mono text-xs uppercase tracking-[0.2em] text-neutral-600">
                      Project photo coming soon
                    </span>
                  </div>
                )}
              </div>
              <div className="p-7">
                <h2 className="font-heading text-xl font-bold text-white">{p.title}</h2>
                {p.blurb && <p className="mt-3 text-sm leading-relaxed text-neutral-400">{p.blurb}</p>}
                <dl className="mt-5 space-y-3 text-sm">
                  <div className="flex gap-3">
                    <dt className="w-24 shrink-0 font-mono text-xs uppercase tracking-wide text-neutral-500">Material</dt>
                    <dd className="text-neutral-200">{p.material}</dd>
                  </div>
                  <div className="flex gap-3">
                    <dt className="w-24 shrink-0 font-mono text-xs uppercase tracking-wide text-neutral-500">Process</dt>
                    <dd className="text-neutral-200">{p.process}</dd>
                  </div>
                  <div className="flex gap-3">
                    <dt className="w-24 shrink-0 font-mono text-xs uppercase tracking-wide text-neutral-500">Challenge</dt>
                    <dd className="text-neutral-400">{p.challenge}</dd>
                  </div>
                  <div className="flex gap-3">
                    <dt className="w-24 shrink-0 font-mono text-xs uppercase tracking-wide text-neutral-500">Result</dt>
                    <dd className="text-neutral-400">{p.result}</dd>
                  </div>
                </dl>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex items-start gap-3 border-l-2 border-orange-500 bg-neutral-900 p-5">
          <Info className="mt-0.5 shrink-0 text-orange-500" size={20} />
          <p className="text-sm text-neutral-300">
            Customer-sensitive details are omitted. Project examples may be simplified or representative.
          </p>
        </div>
      </section>
    </div>
  );
}
